import type { MRT_ColumnDef, MRT_RowData } from "material-react-table";

export type EntityListColumnAppearance = "hub" | "legacy";

const releaseFixedColumnGrowth = <Data extends MRT_RowData>(
    column: MRT_ColumnDef<Data, any>,
): MRT_ColumnDef<Data, any> => {
    const resolvedChildren =
        column.columns === undefined ?
            undefined
        :   column.columns.map((childColumn) => releaseFixedColumnGrowth(childColumn));

    if (column.grow !== false && resolvedChildren === undefined) return column;

    const resolvedColumn = { ...column };
    if (resolvedColumn.grow === false) delete resolvedColumn.grow;
    if (resolvedChildren !== undefined) resolvedColumn.columns = resolvedChildren;

    return resolvedColumn;
};

export const resolveEntityListColumns = <Data extends MRT_RowData>(
    columns: MRT_ColumnDef<Data, any>[],
    appearance: EntityListColumnAppearance,
): MRT_ColumnDef<Data, any>[] => {
    if (appearance === "legacy") return columns;

    return columns.map((column) => releaseFixedColumnGrowth(column));
};
